import { useAuth } from 'components/context/AuthContext';

/**
 * Returns whether the user has the required business data (website_url, business_details)
 * to create campaigns. These fields are needed by the campaign creation flow.
 */
export const useCanCreateCampaign = () => {
  const { auth } = useAuth();
  const websiteUrl = auth?.user?.website_url ?? auth?.user?.active_brand?.website_url ?? '';
  const businessDetails = auth?.user?.business_details ?? auth?.user?.active_brand?.business_details ?? '';

  const hasWebsiteUrl = Boolean(websiteUrl && String(websiteUrl).trim());
  const hasBusinessDetails = Boolean(businessDetails && String(businessDetails).trim());

  const canCreateCampaign = hasWebsiteUrl && hasBusinessDetails;
  const missingFields = [];
  if (!hasWebsiteUrl) missingFields.push('URL del sitio web');
  if (!hasBusinessDetails) missingFields.push('detalles del negocio');

  return { canCreateCampaign, hasWebsiteUrl, hasBusinessDetails, missingFields };
};
